/**
 * Inert list of Tests assigned to a Company (11-iframe-embed/01 § Story 89).
 *
 * Rendered by `pages/company/assignments/AssignmentsPage.tsx`. The data
 * binding (TanStack Query → `state/assignments/api.ts`) layers in with the
 * parent feature's app-shell issue; this component takes `items` as a prop
 * so it's already testable / Storybook-able.
 */

import type { AssignedTestItem } from '../../state/assignments/api.ts';

export interface AssignedTestsListProps {
  items: AssignedTestItem[];
}

export function AssignedTestsList(props: AssignedTestsListProps): JSX.Element {
  if (props.items.length === 0) {
    return (
      <p className="font-sans text-body text-muted">
        No Tests assigned to this Company yet. A System Admin must assign Tests
        before hiring managers can issue Share Tokens against them.
      </p>
    );
  }
  return (
    <ul className="divide-y divide-muted/20">
      {props.items.map((t) => (
        <li key={t.id} className="flex items-baseline gap-4 py-3">
          <span className="font-sans text-body text-ink">{t.title}</span>
          <span className="font-mono text-xs text-muted-2">
            {t.track ?? ''} {t.level ?? ''}
          </span>
          <span className="ml-auto font-mono text-xs text-muted">
            {String(t.estimated_minutes)} min · pass {String(t.pass_mark)}%
          </span>
        </li>
      ))}
    </ul>
  );
}
